
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import Header from './components/header/header';
import Home from './pages/home/Home';
import MovieList from './components/movielist/movieList';
import Movie from './pages/movieDetail/movie';
import Footer from './components/footer/footer';

function App() {
  return (
    <div className="App">
      <Router>
      <Header/>
        <Routes>
            <Route index element={<Home/>}></Route>
            <Route path="movie/:id" element={<Movie/>}></Route>
            <Route path="movies/:type" element={<MovieList/>}></Route>
            <Route path="/*" element={<h1>Error Page</h1>}></Route>
        </Routes>
        <Footer/>
      </Router>  
    </div>
  );
}

export default App;
